// extracted by mini-css-extract-plugin
module.exports = {"alert":"CommonAlert_alert__uJUsy","close-btn":"CommonAlert_close-btn__3BPb4"};